import React from "react";

const Tooltip = ({ visible, x, y, title, subtitle }) => {
  if (!visible) return null;
  return (
    <div
      style={{
        position: "absolute",
        left: x,
        top: y,
        background: "#111827",
        color: "#f9fafb",
        padding: "6px 8px",
        borderRadius: 6,
        fontSize: 12,
        boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
        pointerEvents: "none",
        whiteSpace: "pre-line",
        zIndex: 10,
      }}
    >
      <div>{title}</div>
      {subtitle ? <div style={{ opacity: 0.8 }}>{subtitle}</div> : null}
    </div>
  );
};

export default Tooltip;
